import util from '../util'
const base = '/cheetah/service/s:oa:oa.srv.';

export default {
  /**
   * 匹配文件字
   * @param params
  *  @param params.belongModule        所属模块     belongModule和belongFlow两者至少一个必选
  *  @param params.belongFlow          所属流程     belongModule和belongFlow两者至少一个必选
  *  @param params.belongFileFormat    所属文件格式
  *  @param params.belongUnit          所属单位
  *  @param params.belongDept          所属部门
  *  return [{
  *      id                fileWordId#fileWordName
  *      fileWordId        文件字ID
  *      fileWordName      文件字
  *      wordMaxNum         最大号
  *      generationFormula  生成公式
  *      wordInvalidNum     禁用号（跳号）
  *      wordLoseNum        断号
  * }]
   */
  listMatchFileWord(params) {
    // return Promise.resolve({
    //   "result": [
    //     {
    //       "fileWordName": "广美",
    //       "createTime": "2018-05-23 13:23:48",
    //       "createYearMonth": "201805",
    //       "preWordMaxNum": 1,
    //       "belongDeptName": "",
    //       "preWordInvalidNum": "",
    //       "belongModule": "d33f67d2bf876c7e",
    //       "schema": "SYS_DOC_FILE_WORD",
    //       "id": "5a0423963812488a#广美",
    //       "belongFlowName": "",
    //       "repository": "REP_01",
    //       "createYear": 2018,
    //       "generationFormula": "@fldfw[@fldyear-@fldsn]",
    //       "createMonth": 5,
    //       "belongFileFormat": "",
    //       "belongModuleName": "公司发文",
    //       "preWordYear": "",
    //       "belongUnitName": "",
    //       "wordLoseNum": "1,2",
    //       "fileWord": "广美,北美",
    //       "wordYear": "2018",
    //       "belongUnit": "",
    //       "belongFileFormatName": "",
    //       "wordMaxNum": "2",
    //       "belongFlow": "",
    //       "createYearMonthDay": "20180523",
    //       "belongDept": "",
    //       "preWordLoseNum": "",
    //       "createDay": 23,
    //       "wordInvalidNum": "",
    //       "fileWordId": "5a0423963812488a",
    //       "lastModifyTime": "2018-07-04 17:12:38"
    //     },
    //     {
    //       "fileWordName": "北美",
    //       "createTime": "2018-05-23 13:23:48",
    //       "createYearMonth": "201805",
    //       "preWordMaxNum": 1,
    //       "belongDeptName": "",
    //       "preWordInvalidNum": "",
    //       "belongModule": "d33f67d2bf876c7e",
    //       "schema": "SYS_DOC_FILE_WORD",
    //       "id": "5a0423963812488a#北美",
    //       "belongFlowName": "",
    //       "repository": "REP_01",
    //       "createYear": 2018,
    //       "generationFormula": "@fldfw[@fldyear-@fldsn]",
    //       "createMonth": 5,
    //       "belongFileFormat": "",
    //       "belongModuleName": "公司发文",
    //       "preWordYear": "",
    //       "belongUnitName": "",
    //       "wordLoseNum": "1,2",
    //       "fileWord": "广美,北美",
    //       "wordYear": "2018",
    //       "belongUnit": "",
    //       "belongFileFormatName": "",
    //       "wordMaxNum": "2",
    //       "belongFlow": "",
    //       "createYearMonthDay": "20180523",
    //       "belongDept": "",
    //       "preWordLoseNum": "",
    //       "createDay": 23,
    //       "wordInvalidNum": "",
    //       "fileWordId": "5a0423963812488a",
    //       "lastModifyTime": "2018-07-04 17:12:38"
    //     }
    //   ],
    //   "success": true
    // });
    return util.ajax(`${base}listMatchFileWord`, params);
  },

  /**
 * * 生成当年的可选文号
 *  1、跨年则获取最大号；
 *  2、断号、已编号过的、最大号
 * @param params
 *          fileWordId      文件字ID          （必选）
 *          fileWordName    选择的文件字名    （必选）
 *          isExcludeLoseNum 是否不包含断号 true/false
 *
 *          //表单上已编号过的
 *          srcSerialNumber    已编号过的流水号
 *          srcYear            已编号过的年度
 *
 *          //用于获取部门简称
 *          belongDept      所属部门
 *          belongModule    所属模块
 *          belongFlow      所属流程
 * @param user
 * @return [{
 *     whDocNumber     文号
 *     whName         文件字名 或  文件字名_断号
 *     whFileWordId   文件字
 *     whFileWordName 文件字名
 *     whDeptShortName 部门简称名
 *     whYear          年度
 *     whSerialNumber  流水号
 * }]
 */

  generateDocNumber(params) {
    // return Promise.resolve({
    //   "result": [
    //     {
    //       "whDocNumber": "广美[2018-1]",
    //       "whFileWordId": "5a0423963812488a",
    //       "whDeptShortName": "",
    //       "whFileWordName": "广美",
    //       "whSerialNumber": "1",
    //       "whYear": "2018",
    //       "whName": "广美[2018-1]_断号"
    //     },
    //     {
    //       "whDocNumber": "广美[2018-2]",
    //       "whFileWordId": "5a0423963812488a",
    //       "whDeptShortName": "",
    //       "whFileWordName": "广美",
    //       "whSerialNumber": "2",
    //       "whYear": "2018",
    //       "whName": "广美[2018-2]_断号"
    //     },
    //     {
    //       "whDocNumber": "广美[2018-3]",
    //       "whFileWordId": "5a0423963812488a",
    //       "whDeptShortName": "",
    //       "whFileWordName": "广美",
    //       "whSerialNumber": "3",
    //       "whYear": "2018",
    //       "whName": "广美[2018-3]"
    //     }
    //   ].map(x => {
    //     return Object.keys(x).reduce((p, c) => {
    //       p[c] = x[c].replace('广美', params.fileWordName);
    //       return p;
    //     }, {})
    //   }),
    //   "success": true
    // });
    return util.ajax(`${base}generateDocNumber`, params);
  },

  /**
 *   生成上一个年度可选文号
 * @param params
 *          fileWordId      文件字ID          （必选）
 *          fileWordName    选择的文件字名    （必选）
 *
 *          //表单上已编号过的
 *          srcSerialNumber    已编号过的流水号
 *          srcYear            已编号过的年度
 *
 *          //用于获取部门简称
 *          belongDept      所属部门
 *          belongModule    所属模块
 *          belongFlow      所属流程
 * @param user
 * @return [{
 *     whDocNumber     文号
 *     whName         文件字名 或  文件字名_断号
 *     whFileWordId   文件字
 *     whFileWordName 文件字名
 *     whDeptShortName 部门简称名
 *     whYear          年度
 *     whSerialNumber  流水号
 * }]
 */

  generatePreYearDocNumber(params) {
    // return Promise.resolve({
    //   "result": [
    //     {
    //       "whDocNumber": "广美[2017-2]",
    //       "whFileWordId": "5a0423963812488a",
    //       "whDeptShortName": "",
    //       "whFileWordName": "广美",
    //       "whSerialNumber": "2",
    //       "whYear": "2017",
    //       "whName": "广美[2017-2]"
    //     }
    //   ].map(x => {
    //     return Object.keys(x).reduce((p, c) => {
    //       p[c] = x[c].replace('广美', params.fileWordName);
    //       return p;
    //     }, {})
    //   }),
    //   "success": true
    // });
    return util.ajax(`${base}generatePreYearDocNumber`, params);
  },

  generatePreviewDocNumber(params) {
    // return Promise.resolve({
    //   result: {
    //     ...params,
    //     whDocNumber: 'new name ' + Date.now().toString(36),
    //   },
    //   success: true
    // });

    return util.ajax(`${base}generatePreviewDocNumber`, params);
  },

  generateAutoDocNumber(params) {
    // return Promise.resolve({
    //   success: true,
    //   result:         {
    //     "whDocNumber": "广美[2017-2]",
    //     "whFileWordId": "5a0423963812488a",
    //     "whDeptShortName": "",
    //     "whFileWordName": "广美",
    //     "whSerialNumber": "2",
    //     "whYear": "2017",
    //     "whName": "广美[2017-2]"
    //   }
    // });
    return util.ajax(
      "/cheetah/service/s:oa:oa.srv.generateAutoDocNumber",
      params
    );
  }

}





// WEBPACK FOOTER //
// ./src/common/api/oa.srv.js